<template>
    <Dialog :dialog="dlg">
        <v-form ref="form" lazy-validation>
            <Form>
                <FormRow label="Naam">
                    
                    <TextField dusk="name" :rules="model.rules.dep_name" :skeleton="model.isDataLoading" placeholder="Naam" v-model="model.dep_name"></TextField>

                </FormRow>
            </Form>
        </v-form>

    </Dialog>
</template>



<script setup>
    import useModel from '@/models/department'
    import Form from '@controls/forms/Form'
    import FormColumn from '@controls/forms/FormColumn'
    import FormRow from '@controls/forms/FormRow'
    import TextField from '@controls/input/TextField'
    import Dialog from '@shared/ui/dialogs/ActionDialog'

    import { ref } from 'vue'
    import clsDialog from '@cls/clsDialog'

    const form = ref(null); 


    let model = useModel();
    let dlg = ref(
        new clsDialog("department", "Afdeling", model, [form], {
            icon: 'department'
        })).value;

    window.dlg = dlg;

</script>
